import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount } from '@/utils/number';
import { rollbackPcmpMisBatch } from '../api/pcmpMis.api';
import { PCMP_PRE_BATCH_LABELS } from '../constants/pcmpMis.constants';
import type { PcmpMisRollbackPayload, PcmpMisRollbackResult } from '../types/pcmpMis.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useRollbackPcmpMisBatch(
  batchNo: number,
  onSuccess: (result: PcmpMisRollbackResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMisRollbackPayload) => rollbackPcmpMisBatch(batchNo, payload),
    ...pcmpActionCallbacks<PcmpMisRollbackResult>(
      queryClient,
      (result) =>
        `${formatCount(result.rolledBack.length, 'proposal')} rolled back to ${
          PCMP_PRE_BATCH_LABELS[result.paymentSource]
        }`,
      onSuccess,
    ),
  });
}
